export class TransactionReceiptDto {
  public css: string;
  public html: string;
}
